import React from "react";
import { Select } from "antd";
import { selectStyleGoals } from "../../../constants/Constants";
 
export const QuestionGenerator = React.memo(
  ({ text, inputFields, handleInputChange, pillarName, answer }) => {
    const textParts = text.split(/(<[^>]+>)/g).map((part, index) => {
      const matchedField = inputFields.find(
        (field) => `<${field.inputId}>` == part
      );
      
      if (matchedField) {
        const { inputId, inputType, options, minValue, maxValue,label } =
          matchedField;
  
          
        const key = `${pillarName}-${answer.questionId}-${answer.answerId}-${inputId}-${index}`;
        const data = answer?.["response"].find((data) => {
          return data["fieldId"] == inputId;
        });
        const value = data?.["value"] || "";
 
        if (inputType === "number") {
          
          const adjustedMaxValue = label.toLowerCase().includes("percentage")
          ? 100
          : 9999999999
        
          return (
            <input
            value={value}
            type="number"
            key={key}
            min={1}
            max={adjustedMaxValue}
            required
            autoFocus={true}
            maxLength={adjustedMaxValue.toString().length}
            style={{
              outline: "none",
            }}
            onKeyDown={(e) => {
              
              if (["e", "E", "-", ".", "+"].includes(e.key)) {
                e.preventDefault();
              }
            }}
            onChange={(e) => {
              const newValue = e.target.value;
      
              
              if (newValue >= 1 && newValue <= adjustedMaxValue) {
                handleInputChange(
                  pillarName,
                  answer.questionId,
                  inputId,
                  newValue,
                  answer.answerId
                );
              } else if (newValue === "") {
                handleInputChange(
                  pillarName,
                  answer.questionId,
                  inputId,
                  "",
                  answer.answerId
                );
              }
            }}
            className="text-center mx-1 min-w-[75px] w-auto text-[#008080] bg-[#E6F4F1] 
            border-b-[1px] border-dashed border-[#014D4E] mb-[2px] resize-none overflow-hidden focus:border-[primary]"
            
          />

        );
        } else if (inputType === "text") {
          return (
            <input
              value={value}
              type="text"
              key={key}
              required
              onChange={(e) =>
                handleInputChange(
                  pillarName,
                  answer.questionId,
                  inputId,
                  e.target.value,
                  answer.answerId
                )
              }
              className="text-center text-[#008080] mx-1 w-[75px] border-b-[1px] border-dashed border-[#014D4E] bg-[#E6F4F1] mb-[2px]"
            />
          );
        } else if (inputType === "dropdown") {
          return (
            <Select
              value={value}
              key={key}
              style={selectStyleGoals}
              onChange={(selectedValue) =>
                handleInputChange(
                  pillarName,
                  answer.questionId,
                  inputId,
                  selectedValue,
                  answer.answerId
                )
              }
              options={options.map((option) => ({
                value: option,
                label: option,
              }))}
              showSearch
              filterOption={(input, option) =>
                option?.label.toLowerCase().includes(input.toLowerCase())
              }
              className="goals-dropdown"
            />
          );
        }
      } else {
        return part;
      }
    });
 
    return <span>{textParts}</span>;
  }
);
